import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  const goBack = () => navigate("/dashboard");

  return (
    <section className="flex items-center h-full p-16 dark:bg-gray-900 dark:text-gray-100">
      <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
        <div className="max-w-md text-center">
          <h2 className="mb-8 font-extrabold text-9xl dark:text-gray-600">
            <span className="sr-only">Unauthorized</span>401
          </h2>
          <p className="text-2xl font-semibold md:text-3xl">Unauthorized</p>
          <p className="mt-4 mb-8 dark:text-gray-400">
            You do not have access to the requested page.
          </p>
          <p
            className="px-8 py-3 font-semibold rounded dark:bg-violet-400 dark:text-gray-900 cursor-pointer"
            onClick={goBack}
          >
            Back to homepage
          </p>
        </div>
      </div>
    </section>
  );
};

export default Unauthorized;
